module.exports = __webpack_public_path__ + "assets/icon-news.117368bd.svg";